export default __webpack_public_path__ + "static/media/elecGener.9311b86b.jpg";